import { HomeLoanTaxSavingsComponent } from './home-loan-tax-savings/home-loan-tax-savings.component';
import { PersonalLoanMainComponent } from './personal-loan-main/personal-loan-main.component';
import { HomeLoanMainComponent } from './home-loan-main/home-loan-main.component';
import {NgModule}             from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { HomeLoanPageComponent } from "app/loan/home-loan-page/home-loan-page.component";
import { HomeLoanPageResolver } from "app/loan/home-loan-page/home-loan-page-resolve";
import { HomeLoanTransferPageComponent } from "app/loan/home-loan-transfer-page/home-loan-transfer-page.component";
import { HomeLoanTransferPageResolver } from "app/loan/home-loan-transfer-page/home-loan-transfer-page-resolve";
import { PersonalLoanPageComponent } from "app/loan/personal-loan-page/personal-loan-page.component";
import { PersonalLoanPageResolver } from "app/loan/personal-loan-page/personal-loan-page-resolve";
import { PersonalLoanTransferPageComponent } from "app/loan/personal-loan-transfer-page/personal-loan-transfer-page.component";
import { PersonalLoanTransferPageResolver } from "app/loan/personal-loan-transfer-page/personal-loan-transfer-page-resolve";
import { EmiBasicResolverService } from "app/shared/services/emi-basic-resolver.service";
import { CanActivateViaEmiTokenGuard } from "app/emi-data.service";


const loanRoutes: Routes = [
       { 
        path: 'home',
        component: HomeLoanMainComponent,
        children:[
            { path: '', redirectTo: 'new', pathMatch: 'full' },
            {
                path:'new',
                component:HomeLoanPageComponent,
                resolve: {
                    data: HomeLoanPageResolver
                  }
            },
            {
                path:'tax-savings',
                component:HomeLoanTaxSavingsComponent,
                resolve:{
                    data:HomeLoanPageResolver
                }
            },
            {
                path:'transfer',
                component:HomeLoanTransferPageComponent,
                // resolve:{
                //     HomeLoanTransferPageResolver
                // }
            },
          ],
        },
        {
          path:'personal',
          component:PersonalLoanMainComponent,
          children:[
            { path: '', redirectTo: 'new', pathMatch: 'full' },
              {
                  path:'new',
                  component:PersonalLoanPageComponent,
                  resolve:{
                      data: PersonalLoanPageResolver
                  }
              },
              {
                  path:'transfer',
                  component:PersonalLoanTransferPageComponent,
                //   resolve:{
                //     PersonalLoanTransferPageResolver
                //   }
              }
          ]
        }
    ]

@NgModule({
    imports: [
        RouterModule.forChild(loanRoutes)
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanActivateViaEmiTokenGuard,
        PersonalLoanTransferPageResolver,
        PersonalLoanPageResolver,
        HomeLoanPageResolver,
        HomeLoanTransferPageResolver
    ]
})
export class LoanRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/loan/loan-routing.module.ts